import React from 'react';
import isPast from 'date-fns/isPast';
import parseISO from 'date-fns/parseISO';
import { FullMatchFragment } from '../../generated/graphql';
import { useTitle } from '../../useTitle';
import { Head } from '../../components/Head';
import { PreMatchDetails } from './PreMatch/PreMatchDetails';
import { PostMatch } from './PostMatch/PostMatch';
import { getOpenGraphItems } from './opengraph';

interface Props {
  match: FullMatchFragment;
}

export const MatchHome: React.FunctionComponent<Props> = ({ match }) => {
  useTitle(`Match vs ${match.opponent}`);

  const isPostMatch = isPast(parseISO(match.playedAt));

  const { title, description, image } = getOpenGraphItems(match);
  return (
    <>
      <Head>
        <meta name="description" content={description} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Matchhaus" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image:src" content={image} />
        <meta name="twitter:title" content={title} />
      </Head>

      {isPostMatch ? (
        <PostMatch match={match} />
      ) : (
        <PreMatchDetails match={match} />
      )}
    </>
  );
};
